import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import {
  getDocumentsType,
  getUsers,
  createDocumentsTable,
  updateDocumentsTable,
  getCustomers,
} from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";
import { validateDates } from "../../../Utility/function";

export const EditDocumentTable = ({
  showModal,
  setShowModal,
  fetchDocumentTable,
  selectedDocumentTable,
  fetchdata,
  AddorEdit,
}) => {
  const { showLoader, hideLoader, shopItem, UserItem } =
    useContext(WarehouseContext);
  const [formData, setFormData] = useState({
    subcategory: "",
    category_id: "",
    status: "",
    expiry_date: "",
    issued_date: "",
  });
  const [DocumentsType, setDocumentsType] = useState([]);
  const [documents, setDocuments] = useState({}); // Stores uploaded files
  const [users, setUsers] = useState([]);
  const [errors, setErrors] = useState({});
  const [userType, setUserType] = useState(""); // "customer" or "employee"

  useEffect(() => {
    fetchDocumentType();
    fetchUsers();

    if (selectedDocumentTable) {
      setDocuments(selectedDocumentTable?.file_upload || "");
      setFormData({
        emp_id: selectedDocumentTable?.emp_id || "",
        issued_date: selectedDocumentTable?.issued_date || "",
        expiry_date: selectedDocumentTable?.expiry_date || "",
        title: selectedDocumentTable?.title || "",
        description: selectedDocumentTable?.description || "",
        date: selectedDocumentTable?.date || "",
        file_upload:selectedDocumentTable?.file_upload||"",
        created_by_id: selectedDocumentTable?.created_by_id || "",
        status: selectedDocumentTable?.status?.toString() || "",
      });
    } else {
      setFormData({
        emp_id: "",
        title: "",
        description: "",
        date: "",
        created_by_id: "",
        status: "",
      });
    }
  }, [selectedDocumentTable]);

  const fetchDocumentType = async () => {
    try {
      const response = await getDocumentsType();
      if (response.data.data) {
        console.log(response);
        setDocumentsType(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Documents Type data:", error);
    }
  };

  const fetchUsers = async (page = 1, text = "") => {
    try {
      const response = await getUsers(null, text, shopItem.shop_id);
      if (response.data && response.data.data) {
        setUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Failed to fetch user data");
    }
  };

  const handleSubmit = async (e) => {
    showLoader();
    e.preventDefault();
    const validationErrors = {};

    // if (!formData.emp_id) {
    //     validationErrors.emp_id = "Employee is required.";
    // }
    // if (!formData.title) {
    //     validationErrors.title = "Title is required.";
    // }
    // if (!formData.description) {
    //     validationErrors.description = "Description is required.";
    // }
    // if (!formData.created_by_id) {
    //     validationErrors.created_by_id = "Created by is required.";
    // }
    // if (!documents.document) {
    //     validationErrors.document = "Document file is required.";
    // }

    // if (Object.keys(validationErrors).length > 0) {
    //     setErrors(validationErrors);
    //     hideLoader();
    //     return;
    // }
    if (formData.issued_date && formData.expiry_date) {
      var error = validateDates(
        formData.issued_date,
        formData.expiry_date,
        "Issued",
        "Expiry",
        true
      );
      if (error) {
        toast.error(error);
        hideLoader();
        return;
      }
    }

    const formDataObj = new FormData(); // Create FormData instance
    formDataObj.append("emp_id", formData.emp_id);
    formDataObj.append("title", formData.title);
    formDataObj.append("description", formData.description);
    formDataObj.append("date", new Date());
    formDataObj.append("user_type", userType);
    formDataObj.append("issued_date", formData.issued_date);
    formDataObj.append("expiry_date", formData.expiry_date);
    formDataObj.append("created_by", formData.created_by_id);
    formDataObj.append("created_by_id", UserItem?.user_id);
    formDataObj.append(
      "status",
      !selectedDocumentTable ? "1" : formData.status
    );
    formDataObj.append("shop_id", shopItem?.shop_id);
    if (documents?.document) {
      formDataObj.append("file_upload", documents.document);
    }

    try {
      if (AddorEdit) {
        await createDocumentsTable(formDataObj); // Pass FormData
        hideLoader();
        toast.success("Documents Table Added successfully");
      } else {
        await updateDocumentsTable(
          selectedDocumentTable?.document_id,
          formDataObj
        );
        hideLoader();
        toast.success("Documents Table Updated successfully");
      }
      handleCancel();
      fetchDocumentTable();
    } catch (error) {
      hideLoader();
      if (error.response && error.response.data) {
          toast.error(error.response.data.message || "Error saving data");
      } else {
          toast.error("Error saving data");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      setDocuments((prevState) => ({
        ...prevState,
        [name]: files[0], // Store the file object
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormData({
      document_type_id: "",
      emp_id: "",
      title: "",
      description: "",
      date: "",
      created_by_id: "",
      status: "",
      userType:"",
    });
    setDocuments((prev) => ({
    ...prev,
    document: null,
  }));
  };

  const handleUserTypeChange = async (e) => {
    const selectedType = e.target.value;
    setUserType(selectedType);
    setFormData({ ...formData, emp_id: "" });

    try {
      let response;
      if (selectedType === "employee") {
        response = await getUsers(); // Replace with your API call
      } else if (selectedType === "customer") {
        response = await getCustomers(); // Replace with your API call
      }

      if (response?.data?.data) {
        setUsers(response.data.data);
      } else {
        setUsers([]);
        toast.error(`No ${selectedType}s found.`);
      }
    } catch (error) {
      console.error(`Error fetching ${selectedType}s:`, error);
      toast.error(`Error fetching ${selectedType}s`);
    }
  };

  


  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  {selectedDocumentTable
                    ? "Edit Documents Table"
                    : "Add  Documents Table"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleCancel()}
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3">
                    <label>Title </label>
                    <div className="col-12">
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                      {errors.title && (
                        <small className="text-danger">{errors.title}</small>
                      )}
                    </div>
                  </div>
                  {/* <div className="form-group mb-3">
                                        <label>Document Type</label>
                                        <div className="col-12">
                                            {DocumentsType.length > 0 && (
                                                <select
                                                    name="document_type_id"
                                                    value={formData.document_type_id}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Document Type</option>
                                                    {DocumentsType?.map((cat) => (
                                                        <option key={cat.id} value={cat.id}>
                                                            {cat.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}

                                            {errors.document_type_id && (
                                                <small className="text-danger">{errors.document_type_id}</small>
                                            )}
                                        </div>
                                    </div> 

                                    <div className="form-group mb-3">
                    <label>Employee</label>
                    <div className="col-12">
                      <select
                        name="emp_id"
                        value={formData.emp_id}
                        onChange={handleChange}
                        className="form-control"
                        // required
                      >
                        <option value="">Select Employee</option>
                        {users?.map((cat) => (
                          <option key={cat.user_Id} value={cat.user_Id}>
                            {cat.full_name}
                          </option>
                        ))}
                      </select>
                      {errors.emp_id && (
                        <small className="text-danger">{errors.emp_id}</small>
                      )}
                    </div>
                  </div>.



                                    */}
      <div className="form-group mb-3">
        <label>User Type</label>
        <select
          className="form-control"
          value={userType}
          onChange={handleUserTypeChange}
        >
          <option value="">Select User Type</option>
          <option value="customer">Customer</option>
          <option value="employee">Employee</option>
        </select>
      </div>

      {/* Second Dropdown Based on Selection */}
      {userType && (
        <div className="form-group mb-3">
          <label>{userType === "employee" ? "Employee" : "Customer"}</label>
          <div className="col-12">
            <select
              name="emp_id"
              value={formData.emp_id}
              onChange={handleChange}
              className="form-control"
            >
              <option value="">
                Select {userType === "employee" ? "Employee" : "Customer"}
              </option>
              {users?.map((user) => (
                <option key={user.user_Id} value={user.user_Id}>
                  {user.full_name || user.name}
                </option>
              ))}
            </select>
            {errors.emp_id && (
              <small className="text-danger">{errors.emp_id}</small>
            )}
          </div>
        </div>
      )}

                  {/* <div className="form-group mb-3">
                                        <label>date</label>
                                        <div className="col-12">
                                            <input
                                                type="date"
                                                name="date"
                                                value={formData.date}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.date && (
                                                <small className="text-danger">{errors.date}</small>
                                            )}
                                        </div>
                                    </div> */}
                  <div className="form-group mb-3">
                    <label>Issued Date</label>
                    <div className="col-12">
                      <input
                        type="date"
                        name="issued_date"
                        value={formData.issued_date}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                      {errors.date && (
                        <small className="text-danger">
                          {errors.issued_date}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="form-group mb-3">
                    <label>Expiry Date</label>
                    <div className="col-12">
                      <input
                        type="date"
                        name="expiry_date"
                        value={formData.expiry_date}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                      {errors.date && (
                        <small className="text-danger">
                          {errors.expiry_date}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="form-group mb-3">
                    <label>Upload Document</label>
                    <div className="col-12">
                      <input
                        type="file"
                        name="document"
                        accept=".csv, .xls, .xlsx, .doc, .docx, .pdf, .jpg, .png"
                        onChange={handleChange}
                        className="form-control"
                        required={selectedDocumentTable ? false : true}
                      />
                      {documents.document ? (
                        <small className="text-success">
                          Uploaded: {documents.document.name}
                        </small>
                      ) : selectedDocumentTable?.file_upload ? (
                        <small className="text-success">
                          Previously Uploaded: {selectedDocumentTable.file_upload.split('/').pop()}
                        </small>
                      ) : null}

                      {errors.document && (
                        <small className="text-danger">{errors.document}</small>
                      )}
                    </div>
                  </div>
                  {/* <div className="form-group mb-3">
                                        <label>created by</label>
                                        <div className="col-12">
                                            <input
                                                type="text"
                                                name="created_by_id"
                                                value={formData.created_by_id}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.created_by_id && (
                                                <small className="text-danger">{errors.created_by_id}</small>
                                            )}
                                        </div>
                                    </div> */}
                  <div className="form-group mb-3">
                    <label>Description</label>
                    <div className="col-12">
                      <textarea
                        type="text-area"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="form-control"
                      />
                      {errors.description && (
                        <small className="text-danger">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>
                  {selectedDocumentTable && (
                    <div className="form-group mb-3">
                      <label>Status</label>
                      <select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        className="form-control"
                      >
                        <option value="" disabled>
                          Select Status
                        </option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  )}
                  <button type="submit" className="btn btn-success float-end">
                    {selectedDocumentTable
                      ? "Update Document Table"
                      : "Add Document Table"}
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="btn btn-secondary ml-2 float-end me-1"
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
